import { useEffect, useState, useRef } from "react";
import Spot from "./Spot";
import PlayBtn from "./PlayBtn";

export default function MediaWrap({ params }) {
  const {
    mediaUrl,
    type,
    align,
    ratioType,
    additionalClass,
    alt,
    bordered,
    hotspot,
  } = params;

  const videoRef = useRef(null);

  const [loaded, setLoaded] = useState(false);
  const [playing, setPlaying] = useState(true);

  useEffect(() => {
    !loaded && setLoaded(true);
  }, [loaded, playing]);

  const startVideo = () => {
    videoRef.current.pause();
    setPlaying(false);
  };

  const pauseVideo = () => {
    videoRef.current.play();
    setPlaying(true);
  };

  const handleVideoBtn = () => {
    if (playing) {
      startVideo();
    } else {
      pauseVideo();
    }
  };

  return (
    <div
      className={`ob-media ${align ? align : ""} ${
        ratioType ? ratioType : ""
      } ${additionalClass ? additionalClass : ""}`}
    >
      <div>
        <div
          className={`ob-media-wrap ${bordered === true ? "ob-bordered" : ""}`}
        >
          {type === "video" && (
            <>
              <video
                autoPlay
                loop
                muted
                playsInline
                preload="none"
                ref={videoRef}
              >
                <source src={mediaUrl} type="video/mp4" />
              </video>
              <PlayBtn handleVideoBtn={handleVideoBtn} playing={playing} />
            </>
          )}

          {type === "image" && (
            <div className="ob-img-container">
              {hotspot && <Spot params={hotspot} />}
              {loaded === true && (
                <img src={mediaUrl} alt={alt} onLoad={() => setLoaded(true)} />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
